export default __webpack_public_path__ + "static/media/ic_text.af2561c0.svg";